<script>
  import Customaddposition from "./Customaddposition.svelte";
  import Customeditposition from "./Customeditposition.svelte";
  import { createForm } from "svelte-forms-lib";
  import { onMount } from "svelte";

  //forms
  let stateForm;

  let tnd = new Date();
  let mnth;

  const mnthfunc = () => {
    if (tnd.getMonth() + 1 < 10) {
      mnth = "0" + (tnd.getMonth() + 1);
    } else {
      mnth = tnd.getMonth() + 1;
    }
  };
  let date;
  const datefunc = () => {
    if (tnd.getDate() < 10) {
      date = "0" + tnd.getDate();
    } else {
      date = tnd.getDate();
    }
  };

  mnthfunc();
  datefunc();

  let maxDate = tnd.getFullYear() + "-" + mnth + "-" + date;

  let editadd;

  $: if ($form.exit > $form.entry) {
    $form.exit = $form.entry;
  }

  function addProd() {
    editadd = Customaddposition;
    setTimeout(() => {
      document.getElementById("add").click();
    }, 130);
  }

  $: if ($form) {
    if (stateForm == "edit") {
      let strategy = encodeURI(JSON.stringify($form));
      window.history.pushState("", "", `?strategy=${strategy}`);
    }
  }
  onMount(async () => {
    let params = new URLSearchParams(window.location.search);
    if (params.has("strategy")) {
      $form = JSON.parse(params.get("strategy"));
    }
    stateForm = "edit";

    if (
      localStorage.getItem("scrips") === null ||
      localStorage.getItem("scripsinfo") === null
    ) {
      const data = await fetch(
        "https://raw.githubusercontent.com/yashpulse/stockdata/main/scrips.json"
      );
      let scripset = await data.json();
      localStorage.setItem("scrips", JSON.stringify(scripset));
      const data2 = await fetch(
        "https://raw.githubusercontent.com/yashpulse/stockdata/main/scripsinfo.json"
      );
      let scripsinf = await data2.json();
      localStorage.setItem("scripsinfo", JSON.stringify(scripsinf));
    }
  });

  const {
    form,
    errors,
    state,
    handleChange,
    handleSubmit,
    handleReset,
  } = createForm({
    initialValues: {
      positions: [],
    },
    onSubmit: (values) => {
      alert(JSON.stringify(values));
    },
  });
  const add = (data) => {
    $form.positions = $form.positions.concat(data);
    $errors.positions = $errors.positions.concat(data);
  };

  const remove = (i) => () => {
    $form.positions = $form.positions.filter((u, j) => j !== i);
    $errors.positions = $errors.positions.filter((u, j) => j !== i);
  };

  //get Data from Modal
  function handleMessage(event) {
    add(event.detail);
  }
  //Edit
  function handleEdit(event) {
    $form.positions[toSendtoEdit.pos] = event.detail;
    localStorage.removeItem("modify");
    editadd = "";
    toSendtoEdit = {};
  }

  let toSendtoEdit = {};
  const modify = (i) => () => {
    editadd = Customeditposition;
    toSendtoEdit = {};
    toSendtoEdit = $form.positions[i];
    toSendtoEdit.pos = i;
    localStorage.setItem("modify", JSON.stringify(toSendtoEdit));
    setTimeout(() => {
      document.getElementById("tomodify").click();
    }, 130);
  };
</script>

<div class="col-12">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Positions</h3>
      <div class="ms-auto">
        <button
          class="btn btn-outline-primary d-none d-sm-inline-block"
          on:click={addProd}
        >
          <!-- Download SVG icon from http://tabler-icons.io/i/plus -->
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            ><path stroke="none" d="M0 0h24v24H0z" fill="none" /><line
              x1="12"
              y1="5"
              x2="12"
              y2="19"
            /><line x1="5" y1="12" x2="19" y2="12" /></svg
          >
          Add
        </button>
        <button
          data-bs-toggle="modal"
          id="add"
          data-bs-target="#modal-add"
          hidden
        />
        <button
          class="btn btn-outline-primary d-sm-none btn-icon"
          on:click={addProd}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            class="icon"
            width="24"
            height="24"
            viewBox="0 0 24 24"
            stroke-width="2"
            stroke="currentColor"
            fill="none"
            stroke-linecap="round"
            stroke-linejoin="round"
            ><path stroke="none" d="M0 0h24v24H0z" fill="none" /><line
              x1="12"
              y1="5"
              x2="12"
              y2="19"
            /><line x1="5" y1="12" x2="19" y2="12" /></svg
          >
        </button>
      </div>
    </div>
    <div class="table-responsive mb-1">
      <table class="table card-table table-vcenter text-nowrap datatable">
        <thead>
          <tr>
            <th class="w-1">b/s </th>
            <th>symbol</th>
            <th>type</th>
            <th>entry</th>
            <th>profit target</th>

            <th>stop loss</th>
            <th>expiry</th>
            <th>lots</th>
            <th />
          </tr>
        </thead>
        {#if $form.positions.length >= 1}
          <tbody>
            {#each $form.positions as position, j}
              <tr>
                <td
                  >{#if position.side == "B"}
                    <span class="bg-green-lt"> {position.side} </span>
                  {/if}
                  {#if position.side == "S"}
                    <span class="bg-red-lt"> {position.side} </span>
                  {/if}
                </td>
                <td><span>{position.scrip}</span> </td>
                <td>
                  <span>{position.type}</span>
                </td>
                <td>
                  {#if position.entryby == "value"}
                    <span>₹{position.entryvalue}</span>
                  {/if}
                  {#if position.entryby == "strike"}
                    {#if position.entryvalue > 0}
                      <span>ATM + {position.entryvalue}</span>
                    {/if}
                    {#if position.entryvalue < 0}
                      <span>ATM {position.entryvalue}</span>
                    {/if}
                    {#if position.entryvalue == 0}
                      <span>ATM</span>
                    {/if}
                  {/if}
                </td>
                <td>
                  {#if position.ptby == "percent"}
                    {position.pt}%
                  {/if}
                  {#if position.ptby == "points"}
                    ₹{position.pt}
                  {/if}
                </td>
                <td>
                  {#if position.slby == "percent"}
                    {position.sl}%
                  {/if}
                  {#if position.slby == "points"}
                    ₹{position.sl}
                  {/if}
                </td>
                <td> {position.expiry} </td>
                <td>{position.lots}</td>
                <td class="col-lg-2">
                  <button
                    class="btn btn-outline-warning d-none d-sm-inline-block"
                    on:click={modify(j)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon-tabler icon-tabler-edit"
                      width="44"
                      height="44"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path
                        d="M9 7h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3"
                      />
                      <path
                        d="M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3"
                      />
                      <line x1="16" y1="5" x2="19" y2="8" />
                    </svg>
                    Modify
                  </button>
                  <button
                    data-bs-toggle="modal"
                    data-bs-target="#modal-modify"
                    id="tomodify"
                    hidden
                  />
                  <button
                    class="btn btn-outline-warning d-sm-none btn-icon"
                    on:click={modify(j)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon-tabler icon-tabler-edit"
                      width="44"
                      height="44"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <path
                        d="M9 7h-3a2 2 0 0 0 -2 2v9a2 2 0 0 0 2 2h9a2 2 0 0 0 2 -2v-3"
                      />
                      <path
                        d="M9 15h3l8.5 -8.5a1.5 1.5 0 0 0 -3 -3l-8.5 8.5v3"
                      />
                      <line x1="16" y1="5" x2="19" y2="8" />
                    </svg>
                  </button>

                  <button
                    class="btn btn-outline-danger d-none d-sm-inline-block"
                    on:click={remove(j)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon-tabler icon-tabler-trash"
                      width="44"
                      height="44"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <line x1="4" y1="7" x2="20" y2="7" />
                      <line x1="10" y1="11" x2="10" y2="17" />
                      <line x1="14" y1="11" x2="14" y2="17" />
                      <path
                        d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"
                      />
                      <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                    </svg>
                    Delete
                  </button>
                  <button
                    class="btn btn-outline-danger d-sm-none btn-icon"
                    on:click={remove(j)}
                  >
                    <svg
                      xmlns="http://www.w3.org/2000/svg"
                      class="icon icon-tabler icon-tabler-trash"
                      width="44"
                      height="44"
                      viewBox="0 0 24 24"
                      stroke-width="1.5"
                      stroke="currentColor"
                      fill="none"
                      stroke-linecap="round"
                      stroke-linejoin="round"
                    >
                      <path stroke="none" d="M0 0h24v24H0z" fill="none" />
                      <line x1="4" y1="7" x2="20" y2="7" />
                      <line x1="10" y1="11" x2="10" y2="17" />
                      <line x1="14" y1="11" x2="14" y2="17" />
                      <path
                        d="M5 7l1 12a2 2 0 0 0 2 2h8a2 2 0 0 0 2 -2l1 -12"
                      />
                      <path d="M9 7v-3a1 1 0 0 1 1 -1h4a1 1 0 0 1 1 1v3" />
                    </svg>
                  </button>
                </td>
              </tr>
            {/each}
          </tbody>
        {/if}
      </table>
    </div>
  </div>
</div>

<!--Strategy Setting-->

<div class="col-12">
  <div class="card">
    <div class="card-header">
      <h3 class="card-title">Strategy Settings</h3>
    </div>
    <div class="modal-content">
      <div class="modal-body">
        <div class="row">
          <div class="col-lg-3">
            <div class="mb-3">
              <span class="form-label mb-3">Square Off </span>
              <div>
                <label class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    bind:group={$form.squareoff}
                    value="oneleg"
                    checked
                  />
                  <span class="form-check-label">One Leg</span>
                </label>
                <label class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="radio"
                    bind:group={$form.squareoff}
                    value="allleg"
                  />
                  <span class="form-check-label">All Legs</span>
                </label>
              </div>
            </div>
          </div>
          <div class="col-lg-2">
            <span class="form-label">Holding Period </span>

            <div class="mb-3">
              <select
                class="form-select"
                on:blur={(() => ($form.entry = ""), ($form.exit = ""))}
                bind:value={$form.hlperiod}
              >
                <option value="intraday" selected>Intraday</option>
                <option value="positional">Positional</option>
              </select>
            </div>
          </div>
          {#if $form.hlperiod == "positional"}
            <div class="col-lg-3">
              <div class="mb-3">
                <span class="form-label"
                  >Entry Date: {#if $form.entry >= 0}
                    <span class="text-muted"
                      >{$form.entry} days before expiry</span
                    >
                  {/if}
                </span>
                <div class="mb-3" />
                <input
                  type="range"
                  class="form-range mb-2"
                  bind:value={$form.entry}
                  min="0"
                  max="80"
                  step="1"
                />
              </div>
            </div>
            <div class="col-lg-3">
              <div class="mb-3">
                <span class="form-label"
                  >Exit Date: {#if $form.exit >= 0}
                    <span class="text-muted"
                      >{$form.exit} days before expiry</span
                    >
                  {/if}</span
                >
                <div class="mb-3" />
                <input
                  type="range"
                  class="form-range mb-2"
                  bind:value={$form.exit}
                  min="0"
                  max="80"
                  step="1"
                />
              </div>
            </div>
          {/if}
          <div class="col-lg-8">
            <div class="mb-3">
              <div>
                <label class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    on:change={(() => ($form.Strptby = ""), ($form.Strpt = ""))}
                    bind:checked={$form.isStrPt}
                  />
                  <span class="form-check-label"
                    >Set Strategy Profit Target</span
                  >
                </label>
                <label class="form-check form-check-inline">
                  <input
                    class="form-check-input"
                    type="checkbox"
                    on:change={(() => ($form.Strslby = ""), ($form.Strsl = ""))}
                    bind:checked={$form.isStrSl}
                  />
                  <span class="form-check-label">Set Strategy Stop Loss</span>
                </label>
              </div>
            </div>
          </div>

          <!--Strategy Profit-->

          <div class="row">
            {#if $form.isStrPt}
              <div class="col-lg-3">
                <div class="mb-3">
                  <span class="form-label">Profit Target By</span>
                  <div class="form-selectgroup">
                    <label class="form-selectgroup-item">
                      <input
                        type="radio"
                        bind:group={$form.Strptby}
                        on:change={() => ($form.Strpt = "")}
                        class="form-selectgroup-input"
                        value="percent"
                      />
                      <span class="form-selectgroup-label">Trade value (%)</span
                      >
                    </label>
                    <label class="form-selectgroup-item">
                      <input
                        type="radio"
                        bind:group={$form.Strptby}
                        on:change={() => (form.Strpt = "")}
                        class="form-selectgroup-input"
                        value="points"
                      />
                      <span class="form-selectgroup-label">Trade value (₹)</span
                      >
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="mb-3">
                  {#if $form.Strptby == "percent"}
                    <span class="form-label">Trade Value %</span>
                    <div class="input-group input-group-flat">
                      <input
                        type="number"
                        class="form-control text-end pe-3"
                        min="0"
                        bind:value={$form.Strpt}
                        autocomplete="off"
                      />
                      <span class="input-group-text"> % </span>
                    </div>
                  {/if}
                  {#if $form.Strptby == "points"}
                    <span class="form-label">Trade Value ₹</span>
                    <div class="input-group input-group-flat">
                      <span class="input-group-text"> ₹ </span>
                      <input
                        type="number"
                        min="0"
                        class="form-control ps-0"
                        bind:value={$form.Strpt}
                        autocomplete="off"
                      />
                    </div>
                  {/if}
                </div>
              </div>
            {/if}

            <!--Strategy Stop Loss-->

            {#if $form.isStrSl}
              <div class="col-lg-3">
                <div class="mb-3">
                  <span class="form-label">Stop Loss By</span>
                  <div class="form-selectgroup">
                    <label class="form-selectgroup-item">
                      <input
                        type="radio"
                        bind:group={$form.Strslby}
                        on:change={() => ($form.Strsl = "")}
                        class="form-selectgroup-input"
                        value="percent"
                      />
                      <span class="form-selectgroup-label">Trade value (%)</span
                      >
                    </label>
                    <label class="form-selectgroup-item">
                      <input
                        type="radio"
                        bind:group={$form.Strslby}
                        on:change={() => (form.Strsl = "")}
                        class="form-selectgroup-input"
                        value="points"
                      />
                      <span class="form-selectgroup-label">Trade value (₹)</span
                      >
                    </label>
                  </div>
                </div>
              </div>
              <div class="col-lg-3">
                <div class="mb-3">
                  {#if $form.Strslby == "percent"}
                    <span class="form-label">Trade Value %</span>
                    <div class="input-group input-group-flat">
                      <input
                        type="number"
                        class="form-control text-end pe-3"
                        max="0"
                        bind:value={$form.Strsl}
                        autocomplete="off"
                      />
                      <span class="input-group-text"> % </span>
                    </div>
                  {/if}
                  {#if $form.Strslby == "points"}
                    <span class="form-label">Trade Value ₹</span>
                    <div class="input-group input-group-flat">
                      <span class="input-group-text"> -₹ </span>
                      <input
                        type="number"
                        max="0"
                        class="form-control ps-0"
                        bind:value={$form.Strsl}
                        autocomplete="off"
                      />
                    </div>
                  {/if}
                </div>
              </div>
            {/if}
          </div>

          <!--Date Start-->
          <div class="col-lg-3">
            <div class="mb-3">
              <span class="form-label">Date From :</span>
              <div class="input-icon">
                <input
                  type="date"
                  class="form-control"
                  placeholder="Select a date"
                  id="datepicker-icon-prepend"
                  bind:value={$form.datefrom}
                  min="2013-01-01"
                  max={maxDate}
                />
              </div>
            </div>
          </div>
          <div class="col-lg-3">
            <div class="mb-3">
              <span class="form-label">Date To :</span>
              <div class="input-icon">
                <input
                  type="date"
                  class="form-control"
                  placeholder="Select a date"
                  id="datepicker-icon-prepend"
                  bind:value={$form.dateto}
                  min="2013-01-01"
                  max={maxDate}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>

<svelte:component
  this={editadd}
  on:message={handleMessage}
  on:messageedit={handleEdit}
/>
